module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('div', {
    staticClass: "back"
  }, [_c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("SELF-DOUBT")])]), _c('h1', {
    staticClass: "chap_stit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_vm._v("Understanding Pain")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Am I the problem?")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I saw the world spinning around me. Our tiny rental car was thrown across four lanes of the highway, struck by an oversized truck at 70 miles per hour. My wife, Jenny, clutched my arm and gasped with desperation, “What is happening to us, Adrian?”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I felt utterly helpless, as my steering and brakes no longer had any effect. I couldn’t do anything to control or slow our car’s trajectory—I could only watch as we passed right in front of oncoming cars and finally smashed into a concrete divider.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It felt like the world slowed down as I looked over to see that Jenny was still there and intact. I then inspected my arms and legs, not knowing if I had broken or lost a limb—I couldn’t feel anything because of the shock and adrenaline. As we slowly crawled out of our rental and saw that it was completely totaled, it was hard to believe that we were physically unharmed.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("With the help of some friendly people who stopped, we filed a police report and got our car towed. The truck that struck us never stopped; it was a hit-and-run accident. But I realized then that during the previous few weeks, we had been side-swiped by an even more powerful force—cultural and organizational shock. It turned out to be the breaking point for us.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("●")]), _vm._v("THREE BOTTLES OF SOY SAUCE")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Three weeks before our accident, Jenny and I picked up that rental car at the Orlando airport and navigated our way to a small town called Winter Park, where we were to go through Cru’s six-week training for new employees.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We arrived at our Rollins College apartment at night, where we picked up some boxes we had shipped out ahead of time. I had to laugh at myself as I unpackaged the three bottles of soy sauce I had packed. It’s not as if there were no grocery stores selling Asian ingredients in Florida, but I guess it gave me comfort to know I could bring something familiar to a new place.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In some ways, my instincts were right. Jenny and I were only among a handful of ethnic minority staff at the training, and most of our peers were white and straight out of college.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The first few days of training were well-organized and packed with activities. Most days, we would get up around 6:30 a.m. to prepare for the day, since I was a teacher’s aide for one of the training classes. We would then hear from speakers, including the president of Cru, Steve Douglass. In the afternoons, Jenny and I attended smaller breakout groups (“sections”) for deeper "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("discussion about topics such as theology. These sections were mostly organized by geographical region, so most of the time we were the only ethnic minorities in the room. However, everyone treated us nicely, and we were doing fine—until we hit our first roadblock.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("●")]), _vm._v("SHOULD I SAY SOMETHING?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("“Be careful of heresy,” our section leader Richard warned as he passed around a stapled packet containing quotes from various philosophies and religious sects that diverged from the Christian faith. He walked our class through why they were false or misleading.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I don’t think his intentions were bad. When I became a Christian and entered college, I majored in religious studies so I could understand the differences between various philosophies and religions from history.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But as Richard went through his packet, and soon my classmates began talking about why these divergent views were dangerous, I felt a bit defensive. I was a Christian like him and everyone else in the classroom, and yet there was something about this approach that bothered me. Maybe it felt a bit like “us and them,” and maybe I couldn’t help but notice that I was different from everyone in my section.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("After all, when the young woman next to me gave her critique about Islam and Buddhism, those were part of the Asian traditions that shaped my grandparents and parents. They weren’t just abstract concepts that I could mark up with a red pen, but were "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("intimately intertwined with my family and cultural history—regardless of whether I agreed with them or not. Nobody else in the classroom could understand this the way Jenny and I did.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A thousand thoughts and reactions went through my head. "), _c('i', [_vm._v("Should I say something? But maybe they’ll think I’m trying to cause controversy. We’ve just started this class, so why stir the pot? Maybe Richard will clarify what he really means, and add more context later.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I froze and didn’t say a word.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But Jenny raised her hand. “If we’re learning to read the Bible in context in this class, isn’t it fair to also look at these passages in their context? We may not agree with them, but these traditions have history, and are sacred to many people.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I looked over at her with gratitude, and then back at the classroom and Richard.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("He looked directly at Jenny, and I couldn’t tell if he was angry or passionate, but he spoke with great emotion. I recall him using the words "), _c('i', [_vm._v("heretics")]), _vm._v(" and "), _c('i', [_vm._v("eternal judgment")]), _vm._v(", but what I remember most was the look on Jenny’s face as she heard the response to her question. She was stunned and confused, but mostly it felt as if she had been silenced—by Richard, and by our classmates’ lack of response.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I couldn’t hear a single word in the class after that.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I tried to wrap my mind around what had just happened. Did Richard understand my wife’s question? Did others in the classroom feel the same way about the packet, or were we the only ones?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("At dinner that day, I pulled aside a classmate and asked him what he thought about what had happened. He told me he didn’t really remember much.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I was starting to second-guess myself like never before.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("●")]), _vm._v("NUMB")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A couple of days later, we did a training exercise for a different class. We were supposed to initiate conversations about spirituality with people in the local community, or people that we knew. It wasn’t an easy thing to do, but Jenny and I had a few deep, respectful, and encouraging conversations through this exercise.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("However, I’ll never forget the evening when I got a knock on my door from one of my classmates, Cindy.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Do you have a few minutes to talk, Adrian?” she asked.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Of course. Is everything okay?” I replied. Cindy lived in the same apartment building as us, and she looked clearly distraught.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Well, not really. I was out talking to people in the community today, and there was a man who had just talked to someone else from our group of trainees. He told me that person had told him in a disrespectful tone that he was going to hell.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Wow, really?”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Yeah. And this didn’t seem right to me. Anyway, I know you’re a teacher’s aide, so do you think we should talk to the teacher about this? Maybe he can make a comment to the class about things like this.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Um . . . absolutely. I think that’s a great idea. I’ll mention it to him tomorrow morning. Thank you so much for telling me "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("about this.” I was genuinely touched by her sensitivity and desire to respect others, which I sensed in the vast majority of my fellow trainees. Although it was hard to hear about her experience, I saw something good here. And it gave me hope.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The next morning, after I had finished my photocopy job for the upcoming lecture, I went up to the teacher sitting in his chair near the podium and explained my conversation with Cindy and what she had experienced.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Do you think you could possibly say something to the class?” I asked.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("He thought for a minute, looked down at his notes, and then gave me a dry smile. “I don’t know if there is anything we can do about that.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I was so surprised that I couldn’t even think of a reply. I sat down in my chair and listened to the lecture, and wondered what Cindy might be thinking.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I realized for the first time that I was starting to feel numb.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("●")]), _vm._v("WOULD IT BE EASIER TO DISAPPEAR?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("These experiences add up. By the end of our third week of training, I realized that our attempts to voice our convictions and values were going nowhere. There was no malicious intent or behavior—only silence or resistance when we tried to suggest any differences of opinion or changes. After a while, I had to wonder, does it really matter whether we say something or not? Will it make any difference? And if not, is this really a place where I can be myself and bring what I have to offer to the table?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("I tried to reach out and build better relationships with Richard and our fellow trainees, but nothing seemed to stick. I felt awkward at social gatherings, and found myself hesitating when Richard or my classmates made comments I disagreed with. I had thought I knew how to handle these kinds of situations, but instead I found myself disengaging and withdrawing.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("There was something new happening inside me that I didn’t yet understand.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This all brought me to my breaking point one evening as my wife collapsed on our apartment couch with exhaustion. She hadn’t been eating much food at meals, as her spirits were so low. I wondered if it might be a healthy decision for us to consider leaving the training early. In desperation, I reached out to some friends for counsel. They were very supportive, but some of them encouraged me to not quit and “finish what we started.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I was torn up inside, and didn’t know what to do. I remember yelling in frustration. I had never doubted myself so much in my life.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So I took out my laptop computer and started to vent my raw emotions. I needed to try to make some sense of what was happening to me. Here’s an excerpt from what I wrote:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_vm._v("Thoughts race through my head: “Stop being so negative. Why is that Asian couple never around at these events?”")]), _c('p', {
    staticClass: "txt_courant_justif retrait_autre"
  }, [_vm._v("The way others look at you, it begins to wear on you. Your thoughts turn into endless speculations. Your frustration turns into imaginary arguments and justifications "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("within your own head. The battles with insecurity, the strange feeling of isolation. If it all became bottled up inside a person, with no outlet or supportive community, it’s easy to visualize the steps along the path to depression.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_autre"
  }, [_vm._v("And so here we are, at the end of week 3, feeling physically drained and emotionally discouraged. For three weeks, we have tried to simply to be who we are, and we have found that we sadly are not able to. Our honesty is met with silence, our perspectives quenched by defensiveness; our contributions do not seem to be appreciated by our peers, nor honored by our leaders. . . . They seem to just disappear like tiny, disconnected dots on a large canvas.")]), _c('p', {
    staticClass: "txt_courant_justif last retrait_autre"
  }, [_vm._v("When we were absent from class for two days last week, I actually wondered, “Will it be less awkward for others, now that we’re not around? Would it just be easier for us to disappear? Would it really make a difference?”")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("That night was one of the longest of my life. In the morning, however, Jenny and I did come up with an idea. It was the weekend and we had a free day, so why not take a short break and go to Disney World? It might help to get some space from everything we were experiencing, and then we could re-evaluate things with fresh eyes afterwards. So we headed off for the day, ready for some relaxation and fun.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("That was the day of our car accident.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When we returned to our apartment that evening, we told some of our peers about what had happened. They were "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("sympathetic, but there wasn’t much anybody did to follow up, let alone ask us about how we were doing emotionally after such a traumatic experience. We actually felt more support from our taxi driver from Haiti, who offered to pray for us as he drove us back to our apartment. That night, we wanted to leave the training—not just because we were in pain, but "), _c('i', [_vm._v("because we felt that nobody could truly see our pain")]), _vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A couple of days later, I set up a meeting with the director of the employee training. I shared with her our experiences and why we were considering leaving. She was gracious and kind, but still encouraged us to continue with the training. When I insisted that there were cultural realities that were impacting us significantly, she finally relented.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I wish I could have explained to the training director the emotional realities I was facing as a minority, or the organizational forces Jenny and I were trying to navigate. But I didn’t fully understand them at the time. What did strike me was that it took us telling people that we were thinking of leaving in order to draw attention to the fact that something was wrong or needed to be addressed.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Again, we weren’t facing malicious behavior, but rather something much more subtle—a culture of power that resisted differences, and a culture of passivity in response to pain. In such an environment, the unspoken message was, “We won’t think about you, unless we’re forced to.” Not unlike our car accident, we felt helpless to stop these forces that had sideswiped and spun us around. This was another hit-and-run that we didn’t see "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("coming, and it struck me even more deeply because it made me question my very identity.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("●")]), _vm._v("DECONSTRUCTION")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Now that I’ve had time to reflect on our training experience, I can see that Jenny and I experienced a key component of the minority experience—self-doubt. This self-doubt comes from repeated experiences of being different, being questioned or regarded with suspicion, and even being silenced and shut down. Self-doubt comes from experiences of pain.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When Richard was deconstructing that booklet of divergent beliefs in our section, he was deconstructing a piece of us. When our classmates were talking about “us” and “them,” part of us felt like “them.” We felt like the “other.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It hurt. I felt naked and exposed in front of the rest of the class.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("After all, feeling like I’m on the outside—that’s part of my experience as a minority. Every time someone asks me “what country I come from” or remarks on how well I speak English, it’s a reminder that maybe I don’t quite belong. As much as I want and try to fit in, I have this sinking feeling that it won’t ever be enough, and I’ll always be on the outside looking in.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I feel alone. Maybe I shouldn’t be here. Maybe I am the “other.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It strikes me that we didn’t start off the training in any great and obvious pain, or with a chip on our shoulders. We came in confident, equipped, and prepared in many ways. So when I started to second-guess my instincts and decisions at every turn, it took me by surprise. My feelings of anger, insecurity, paranoia, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("and even depression—I didn’t expect them, nor did I know what to do with them.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I started to wonder, “Am I not seeing things clearly? Am I the only one who thinks this way? Or maybe, am "), _c('i', [_vm._v("I")]), _vm._v(" the problem?”")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("●")]), _vm._v("INTERNALIZING THE BLAME")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In the past decade, Western societies have become increasingly aware of the realities of shame, especially due to the work of "), _c('i', [_vm._v("Daring Greatly")]), _vm._v(" author Brené Brown and HonorShame.com blogger Jayson Georges. I still remember a 2006 report by CNN on the high rates of suicide among Asian American women between the ages of fifteen and twenty-four and the way this article circulated through minority communities."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-020",
      "id": "ap_ntf-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Taboo topics like suicide, mental health, depression, and shame were finally getting more widespread attention.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Unfortunately, the reports of suicide keep coming in. "), _c('i', [_vm._v("Washington Post")]), _vm._v(" columnist Jeff Yang wrote about a string of four suicides in a span of six months at Palo Alto’s Gunn High School."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-021",
      "id": "ap_ntf-021-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Three of the four students who took their lives were Asian American. Yang writes of the exceedingly high pressure for these kids to succeed academically.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I know this very well myself, as I worked for years as a high school counselor to hundreds of Asian American students, including many from Gunn. I still recall stories of parents telling me to give their children more work to do, even when the teenagers barely had time to sleep or socialize. I remember the students who had hit their breaking point and came to me in tears.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("When these Asian American students could no longer handle the pressure, they didn’t fight back, but instead internalized the pressure and blame on themselves. It was shame and self-blame. The impact of their painful experiences was to conclude that "), _c('i', [_vm._v("they")]), _vm._v(" were the problem. And tragically, when kids have no safe outlet for talking about these things in their own families, sometimes they feel the only way out is to take their own lives. Cindy Ng, the associate dean of students and director of the Asian American Activities Center at Stanford University, describes how failures become internalized for minorities, leading to “feelings of failure and worthlessness.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-022",
      "id": "ap_ntf-022-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Brené Brown makes a clear distinction between shame and guilt. She defines guilt as “holding something we’ve done or failed to do up against our values and feeling psychological discomfort.” This, Brown believes, can be helpful in a way that shame is not. She defines shame as “the intensely painful feeling or experience of believing that we are flawed and therefore unworthy of love and belonging.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-023",
      "id": "ap_ntf-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Andy Crouch published an article in "), _c('i', [_vm._v("Christianity Today")]), _vm._v(" about the dynamics of shame that Western societies are beginning to uncover—especially in contexts such as social media “communities.” He writes of a culture where “people yearn to feel included in the group, a state constantly endangered, fragile, and desperately in need of protection.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-024",
      "id": "ap_ntf-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('i', [_vm._v("New York Times ")]), _vm._v("opinion writer David Brooks agrees with Crouch, writing that our modern shame culture can be “strangely unmerciful to those who disagree and to those who don’t fit in.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-025",
      "id": "ap_ntf-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("As I think of our experiences at Cru’s new staff training, so much of this language of shame resonates. Jenny and I were the ones who disagreed and chose to speak our minds to our section leader, teacher, and other people in leadership. Despite our efforts, we felt all the ways we didn’t fit in as minorities. And as we discovered that “being ourselves” resulted in defensiveness and silencing, we started to "), _c('i', [_vm._v("internalize")]), _vm._v(" the failure and blame. We didn’t just feel guilt as Brown defines it; we began to question whether we were worthy of love and belonging in this group. We began to wonder if we were the ones who were the problem. I didn’t think of taking my own life, but I did wonder if it would just be better if I “went away.” I was starting to grasp the minority experience of "), _c('i', [_vm._v("pain")]), _vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This was a shock to my system, because I had always thought of myself as a confident, socially adjusted person who had assimilated into North American culture. Why was I feeling like this?")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("●")]), _vm._v("NO VACANCY")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As I later discovered, my feelings of self-doubt and shame didn’t just come from inside my head, but from centuries of negative messages in North American society towards ethnic minorities. Daniel Sanchez describes how the majority culture’s stereotypes of Latinos are perpetuated in “educational systems, commercial advertising, and mass media reporting” and contribute to the formation of a negative Latino self-image. He quotes Virgilio Elizondo, who summarizes the process of internalizing blame: “If you hear again and again that you are inferior, good for "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("nothing, incompetent, and lazy, you may eventually begin to believe it yourself.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-026",
      "id": "ap_ntf-026-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In "), _c('i', [_vm._v("The Warmth of Other Suns")]), _vm._v(", Pulitzer Prize–winning author Isabel Wilkerson tells the true story of Robert Joseph Pershing Foster, an African American man looking for a motel room as he drove through Phoenix, Arizona, in 1953. This powerful account illustrates the self-doubt of the minority experience.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Time after time, Foster is turned away from motels—some with a blatant “Vacancy” lighted sign. Although it is clear that he is not welcome because he is black, Foster begins to replay the rejections in his mind and doubt his own approach. He wonders if he hadn’t explained himself well enough, and so he rehearses his speech to the next motel receptionist over and over, “debating with himself as to what he should say.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-027",
      "id": "ap_ntf-027-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Finally, in his exhaustion, Foster decides to confront a motel owner couple, and asks them to simply tell him if they don’t allow blacks to stay over. The husband and wife tell him that they actually don’t agree with segregation practices, but if they were to take Foster in, they would be ostracized by the other motel owners and risk losing their business.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Foster moves on, and later that night describes his plight to a friendly gas station owner. While the owner tries to console him, Foster reflects on his minority experience: he has experienced so much dehumanization that he begins to doubt his own worth and actions. When it becomes clear that he isn’t out of his mind, it doesn’t make things any easier to bear. After all, there is a systemic injustice here that the motel and gas station "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("owners know is wrong, but Foster is still without a motel room, and “nobody of a mind to do anything had done a single thing to change that fact.” Foster concludes, “That made the pain harder, not easier, to bear.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-028",
      "id": "ap_ntf-028-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Foster’s self-doubt wasn’t just in his own head, but came from painful "), _c('i', [_vm._v("realities")]), _vm._v(" of discrimination. When we understand history, this becomes clearer."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-029",
      "id": "ap_ntf-029-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("●")]), _vm._v("MOSES’ MINORITY TRAUMA")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Another example of self-doubt and pain comes straight from the pages of the Bible in the leadership journey of Moses. It is well known that Moses doubted himself—citing numerous reasons why he should not be the person to lead the Israelites—even when confronted by the presence and commands of God (Exodus 3:1–4:17). What kinds of painful realities from Moses’ experiences as a minority might have caused him to have such intense feelings of unworthiness?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Consider that Moses was born in the midst of minority persecution, as all Israelite male babies were ordered by the king of Egypt to be killed or thrown into the Nile River (Exodus 1:15-22). Moses was one of those babies put into the river, so one of his first experiences was abandonment (Exodus 2:1-4). Then he was raised within Egyptian culture—the very people who had killed his own people and now enslaved them. He may not have even discovered his true ethnic identity until he was an adult, which would have not only been confusing but traumatic."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-030",
      "id": "ap_ntf-030-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Perhaps this explains his reaction of killing the Egyptian who was beating an Israelite in the desert (Exodus 2:11-12).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_vm._v("After seeing mostly negative, powerless images of the enslaved Israelites, it is not hard to imagine how Moses might have questioned his own worth and doubted himself. In response, God did not tell Moses to “step up” or “get over his past,” but provided him with a team so he didn’t have to do things alone. God told Moses to work with his brother Aaron and use their different strengths to complement one another (Exodus 4:14-16). Moses, Aaron, and their sister, Miriam, form a team that helps to lead the people of Israel (Exodus 15; Numbers 12). Later, Moses took the advice of his father-in-law, Jethro, to delegate his governing responsibilities among a variety of leaders, so all the pressure wouldn’t be on Moses (Exodus 18:13-27). Throughout Moses’ life, you can see how he slowly grows to accept his responsibilities and gains confidence in his ability to lead (Exodus 33:12-23).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Moses is an intriguing example of a leader that God challenges, but also gives space to heal and grow into leadership—especially through the help of partners and wise advisors. In my experience working with ethnic minority leaders, many tend to doubt themselves because they are starting with so many negative messages and painful experiences from their past. Recognizing the root cause of this self-doubt can help us to be patient and supportive in their leadership journey.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("●")]), _vm._v("TEN YEARS LATER: A CONVERSATION WITH RICHARD")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As for me, self-doubt turned out to be a gift from God. Because I was forced to question myself on such a deep level, I gained "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("greater clarity about why I felt those emotions and what to do about them.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For one, Jenny and I decided to leave our new staff training so we could heal and regroup. We met up with minority leaders from Epic Movement to debrief our experiences. It was in those next few critical months that we gained even greater motivation to continue our work with Cru and Epic. I thought to myself, “Now I understand much more clearly what minorities experience, and how I can serve and support them.” So Jenny and I returned to Florida a few months later to finish up our training, but we were far more equipped and purposeful.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Also, about a decade later I decided to reach out to Richard. Now that I had more clarity, I wanted to share our experiences in his section and to hear his recollections and perspective. I had chosen before to disengage and withdraw from these painful experiences, but I wanted to face them. So I reached out to Richard to see if he had time to talk.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I’ll admit that it was very hard to do this. After all, it had been such a long time since our training, and I didn’t even know if Richard remembered who I was! Also, wouldn’t it just be easier to let bygones be bygones? However, I realized that Richard might not even know that there were bygones at all, because I had never directly told him about our painful experiences in his section.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Fortunately, Richard did remember me, and graciously accepted to take a call. After catching up a bit, I shared about the booklet about “divergent perspectives” and its impact on me and Jenny. At first, Richard felt bad and said that he would never "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v("have given out the booklet if he knew what it would do to us. Then, he questioned whether or not the contents of the booklet were what we remembered them to be. I felt myself starting to drift into self-doubt territory, but then corrected myself and said, “Whatever the booklet said, my experience in the class and training made me feel like I was different from everyone else.”")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My sense was that Richard was struggling to move on from talking about what was in the booklet, and he felt some responsibility and even guilt about the painful experience that Jenny and I had. I felt torn because part of me felt uncomfortable letting him feel my pain. I wanted to own what I could have done differently—for instance, I could have had a direct conversation with him about what was bothering me.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Later in the conversation, Richard asked me, “What was the training like for you as an ethnic minority? Did you feel supported by your peers and able to approach me with your concerns?”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I shared my feelings of self-doubt, insecurity, and paranoia—and how those emotions took me by surprise. I shared that I found it harder than I thought to approach or confront him, because he was white and had a strong, confident personality. I told him that I might have been afraid that if I did voice my emotions, he or other Cru leaders might not accept me.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Richard responded by acknowledging that it was his job to make sure we felt safe in that environment, but that he was also new to his role and didn’t fully understand how to do that for us. He told me how he’s learned a lot in the past decade, and has become more aware of the need to discuss cultural issues, and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_vm._v("understand minorities’ realities. Moreover, he told me of some efforts Cru has made in recent years to improve cultural sensitivity during their new staff training and theological classes. For instance, key assignments for trainees now include studying historical-cultural issues like slavery, and discussion questions acknowledge racial power and ethnic superiority, including the Jewish-Gentile divide."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-031",
      "id": "ap_ntf-031-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Richard and I had a productive conversation, and I told him about my plan to write a book including my experiences at new staff training. A few months later, Richard reached out to me to ask to talk again, as he had remembered another detail that he thought might have impacted our experience at training—a blunt comment he had written on one of our papers. I didn’t even remember this comment, but it touched me that Richard was thinking about what our reality has been as minorities. I walked away from our dialogues with a sense of confirmation that it’s never too late to face unresolved issues from our past, as hard as it was to initiate and navigate these conversations.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Many conversations and relationships such as this are messy, and they don’t often go as we might want or hope. However, I didn’t do it to change Richard, but as a step of personal growth to face my unresolved issues and past. As I’ve taken steps like this, it’s only clarified my sense of purpose in work and life—and shown me where I still need to learn and grow.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Indeed, through all my experiences at Cru’s new staff training, I sensed I was only scratching the surface of the minority experience, and I wanted to learn more about African American, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("Latino, and Native American history with fresh eyes. I thought I was well adjusted to living in the United States, but I learned how much had been suppressed and buried under the surface.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My journey in understanding the minority experience had just begun.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c64d8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap1.vue
// module id = 75
// module chunks = 0